import React, { useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';

function AddCampeonato() {
  const [campeonatoData, setCampeonatoData] = useState({
    nome: '',
    ano: '',
    logo: null,
  });
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setCampeonatoData({ ...campeonatoData, [name]: files[0] });
    } else {
      setCampeonatoData({ ...campeonatoData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('nome', campeonatoData.nome);
    formData.append('ano', campeonatoData.ano);
    formData.append('logo', campeonatoData.logo);

    try {
      const response = await axios.post(`${API_BASE_URL}/wp-json/palpitex/v1/campeonatos`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      alert(response.data.message);
      setCampeonatoData({ nome: '', ano: '', logo: null });
      setError(null);
    } catch (error) {
      setError(error.response?.data?.message || 'Erro ao cadastrar campeonato.');
    }
  };

  return (
    <div className="form-container">
      <h2>Cadastrar Campeonato</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="nome"
          placeholder="Nome do Campeonato"
          value={campeonatoData.nome}
          onChange={handleChange}
        />
        <input
          type="number"
          name="ano"
          placeholder="Ano"
          value={campeonatoData.ano}
          onChange={handleChange}
        />
        <input
          type="file"
          name="logo"
          accept="image/*"
          onChange={handleChange}
        />
        {error && <p className="error">{error}</p>}
        <button type="submit">Cadastrar Campeonato</button>
      </form>
    </div>
  );
}

export default AddCampeonato;